import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Container, Toolbar, IconButton, Button } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import navigation from 'menu-items';
import useConfig from 'hooks/useConfig';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import { openDrawer, setLeftMenuList, setShowDrawer } from 'store/reducers/menu';
import useMain from 'hooks/useMain';
import menuItems from 'menu-items';
import { rFetchBcTypes, setState } from 'store/reducers/comModule';
import { ChevronUp } from 'react-feather';
import { clearLocalStorage, getAccessToken, useLocalStorage } from 'utils/common';
import { sessionConfig } from 'utils/constant';
import { useGetApiUsersProdidSection } from 'api/mic-service/users/users';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));

  const { container, miniDrawer } = useConfig();

  const { useLocation, dispatch, project, useNavigate } = useMain();

  const { getStorage, setStorage, removeStorage } = useLocalStorage();
  const location = useLocation();
  const navigate = useNavigate();

  // add detail checking to show breacrumb
  const isDetail = location.pathname.includes('detail') || location.pathname.includes('batch') || location.pathname.includes('profile');

  const menu = useSelector((state) => state.menu);
  const products = useSelector((state) => state.comModule.products);

  const { drawerOpen, showDrawer, leftMenuList } = menu;
  const bcTypes = useSelector((state) => state.comModule.bcTypes);
  const selectedProduct = useSelector((s) => s.comModule.product);
  const productId = selectedProduct?.Id;

  // Section/left menu: cache per product — do not refetch on every route change
  const { data: sectionData } = useGetApiUsersProdidSection(productId || '', {
    query: {
      enabled: Boolean(getAccessToken() && productId),
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false
    }
  });

  // drawer toggler
  const [open, setOpen] = useState(!miniDrawer || drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      setOpen(!matchDownLG);
      if (!location.pathname.match(/map/gi)) {
        dispatch(openDrawer({ drawerOpen: !matchDownLG }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG]);

  useEffect(() => {
    if (sectionData == null) return;
    dispatch(setLeftMenuList(Array.isArray(sectionData) ? sectionData : []));
  }, [sectionData, dispatch]);

  useEffect(() => {
    if (selectedProduct === '') clearLocalStorage();

    if (!_.isEmpty(products)) {
      let targetProduct = selectedProduct;

      if (location.pathname.match(/map/gi)) {
        targetProduct = products.find(({ ProdName }) => ProdName.includes('Location'));
      } else if (location.pathname.match(/userAdmin/gi) || location.pathname.match(/\/appadmin/gi)) {
        targetProduct = products.find(({ ProdName }) => ProdName.includes('Admin'));
      } else {
        targetProduct = products.find(({ ProdName }) => ProdName.includes('MIC'));
      }

      dispatch(setState(['product', targetProduct]));
      setStorage(sessionConfig.product, targetProduct);
    } else {
      navigate('/product');
    }
  }, [location?.pathname, products]);

  useEffect(() => {
    if (location.pathname.match(/product/g) || location.pathname.match(/project/g) || location.pathname.match(/map/g)) {
      dispatch(setShowDrawer(false));
      return;
    }

    if (location.pathname.match(/map/gi)) {
      dispatch(openDrawer(false));
    }
    dispatch(setShowDrawer(true));

    // return () => {};
  }, [location]);

  useEffect(() => {
    if (project?.ProjId) {
      dispatch(rFetchBcTypes({ projid: project?.ProjId }));
    }
  }, [project?.ProjId]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);
  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />
      {showDrawer && <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />}
      <Box component="main" sx={{ flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar />
        {container && (
          <Container
            maxWidth="lg"
            sx={{ px: { xs: 0, sm: 2 }, position: 'relative', minHeight: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column' }}
          >
            {!isDetail && <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />}
            <Outlet />
            <Footer />
          </Container>
        )}
        {!container && (
          <Box sx={{ position: 'relative', minHeight: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column' }}>
            {!isDetail && <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />}
            <Outlet />
            <Footer />
          </Box>
        )}
      </Box>
      <Button
        variant="contained"
        onClick={() => {
          window?.scrollTo(0, 0);
        }}
        color="primary"
        sx={{
          position: 'fixed',
          right: 40,
          bottom: 50,
          borderRadius: '50%',
          height: '50px',
          minWidth: 0,
          width: '50px'
        }}
      >
        <ChevronUp />
      </Button>
    </Box>
  );
};

export default MainLayout;
